<template>
  <div>
    <el-row>
      <el-col :span="9">
        <div class="inside" style="height: 40px">
          <el-form :inline="true" class="demo-form-inline" :model="searchForm" ref="searchForm">
            <el-form-item style="width: 20vw;">
              <el-input size="medium" style="width: 18vw;" v-model="searchForm.LICENSE_PLATE" placeholder="请输入车牌号" clearable>
              </el-input>
            </el-form-item>
            <el-button size="medium" @click="search()">{{ searchForm.LICENSE_PLATE == tmp ? '刷新定位' : '筛选车辆' }}</el-button>
          </el-form>
        </div>
      </el-col>
      <el-col :span="4" :offset="11">
        <span style="float: right; height: 40px; line-height: 40px">日期：{{ date }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="7">
        <div v-show="Object.keys(carInfo).length > 1"
          style="border: solid 1px #eee; height: 170px; width: 90%; margin-top: 10px; box-shadow: 5px 5px 5px #eee; padding: 10px;">
          <span style="color: #999;">车牌号：{{ carInfo.LICENSE_PLATE }}</span><br><br>
          <span style="color: #999;">司机信息：{{ carInfo.DRIVER }}</span>
          <span style="color: #999; float: right;">联系电话：{{ carInfo.CELLPHONE }}</span><br><br>
          <span style="color: #999;">所在位置：{{ carInfo.address }}</span>
        </div>
        <div id="chart" style="border: solid 1px #eee; height: 170px; width: 90%; margin-top: 10px; box-shadow: 5px 5px 5px #eee; padding: 10px;">
        </div>
        <div style="border: solid 1px #eee; height: 170px; width: 90%; margin-top: 10px; box-shadow: 5px 5px 5px #eee; padding: 10px;">
          <el-col :span="12">
            <span style="color: #999">当日下单项目总数</span><br><br>
            <span style="color: #333; font-size: 24px; font-weight: bolder;">{{ projectCount + '家' }}</span>
          </el-col>
          <el-col :span="12">
            <span style="color: #999">当日销售总额</span><br><br>
            <span style="color: #333; font-size: 24px; font-weight: bolder;">{{ '￥' + totalFee }}</span>
          </el-col>
        </div>
      </el-col>
      <el-col :span="17">
        <div id="container" style="height: 650px; width: 100%; margin-top: 10px;"></div>
      </el-col>
    </el-row>
    <el-row>
      <!-- 地图容器 -->
    </el-row>
  </div>
</template>
<script>
// 引入loader
import AMapLoader from '@amap/amap-jsapi-loader';
import http from '@/assets/common/http';
import date from '../../assets/common/date';

let Amap;

export default {
  data() {
    return {
      searchForm: {
        LICENSE_PLATE: '',
      },
      amap: null, // 声明一个空的map
      icon1: '',
      icon2: '',
      geocoder: null,
      lnglats: [],
      mapCenter: [],
      opinionData: [
        { value: 0, name: '未完成', itemStyle: 'blue' },
        { value: 0, name: '已完成', itemStyle: 'green' },
      ],
      projectCount: 0,
      totalFee: 0,
      totalCount: 0,
      carInfo: { address: '' },
      markers: [],
      data: [],
      zoom: 15,
      tmp: ' ',
    };
  },
  computed: {
    date() {
      let d = date(new Date(), '%F');
      d = d.split('-');
      return `${d[0]}年${d[1]}月${d[2]}日`;
    },
  },
  async created() {
    await this.createMap();
    this.$nextTick(() => {
      this.queryData();
      // setInterval(this.createMap, 10000);
      this.getCarInfo();
    });
  },
  mounted() {
  },
  methods: {
    // 查询当日销售总额及下单项目总数
    queryData() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 13,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        this.projectCount = result[0].PROJECT_COUNT;
        this.totalFee = result[0].TOTAL_FEE;
        // this.createMap();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查询当日配送进度
    async deliveryProgress() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 14,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      await http.post(params).then((result) => {
        if (result[0]) {
          this.opinionData[0].value = result[0].NOT_FINISH_COUNT;
          this.opinionData[1].value = result[0].FINISH_COUNT;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.opinionData[0].value = 0;
          this.opinionData[1].value = 0;
          this.totalCount = 0;
        }
        // this.drewChart();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      this.drewChart();
    },
    // 获取车辆信息
    search() {
      this.tmp = this.searchForm.LICENSE_PLATE;
      this.getCarInfo();
    },
    getCarInfo() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 15,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.LICENSE_PLATE != '') {
        params.LICENSE_PLATE = this.searchForm.LICENSE_PLATE;
      }
      http.post(params).then((result) => {
        this.lnglats = [];
        this.data = [];
        this.carInfo = { address: '' };
        this.markers = [];
        this.amap.clearMap();
        if (result[0]) {
          result.forEach((item) => {
            this.lnglats.push(item.CURRENT_LOCATION);
            this.markers.push(new Amap.Marker({
              position: [item.CURRENT_LOCATION[0], item.CURRENT_LOCATION[1]],
              icon: item.DISPLAY_STATUS == 1 ? this.icon1 : this.icon2,
              anchor: 'center', // 设置点标记锚点
            }));
          });
          this.data = result;
          this.getAddresses();
          this.markers.forEach((item, index) => {
            item.on('click', () => {
              this.carInfo = this.data[index];
              this.amap.setCenter(this.carInfo.CURRENT_LOCATION);
              this.amap.setZoom(this.zoom);
              this.$set(this.searchForm, 'LICENSE_PLATE', this.carInfo.LICENSE_PLATE);
              this.tmp = this.carInfo.LICENSE_PLATE;
            });
          });
          this.amap.add(this.markers);
          if (result.length == 1) {
            this.amap.setCenter(result[0].CURRENT_LOCATION);
            this.amap.setZoom(this.zoom);
            this.carInfo = result[0];
          } else {
            this.amap.setFitView();
          }
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      this.deliveryProgress();
    },
    // 创建地图方法
    async createMap() {
      await AMapLoader.load({
        key: '34dc75c9a73045351c1bfdf86f1d853d', // 申请好的Web端开发者Key，首次调用 load 时必填
        version:
          '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Geocoder'], // 插件列表
      }).then((AMap) => {
        Amap = AMap;
        this.amap = new AMap.Map('container', { // container为容器的id
          zoom: this.zoom, // 初始化地图层级
          center: [116.397477, 39.908692], // 初始化地图中心点
        });
        this.icon1 = new AMap.Icon({
          size: new AMap.Size(43, 50), // 图标尺寸
          image: require('../../assets/images/zzz1.png'), // Icon的图像
          imageSize: new AMap.Size(40, 40), // 根据所设置的大小拉伸或压缩图片
        });
        this.icon2 = new AMap.Icon({
          size: new AMap.Size(43, 50), // 图标尺寸
          image: require('../../assets/images/zzz2.png'), // Icon的图像
          imageSize: new AMap.Size(40, 40), // 根据所设置的大小拉伸或压缩图片
        });
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
      });
      this.geocoder = new Amap.Geocoder();
    },
    // 图表
    drewChart() {
      this.chart = this.$echarts.init(document.getElementById('chart'));
      const option = {
        title: {
          text: '配送进度',
          subtext: '',
          x: 'left',
          y: '0',
          textStyle: {
            color: '#999',
            fontSize: 16,
            fontWeight: 'normal',
          },
        },
        grid: {
          containLabel: true,
          y: '20',
        },
        color: ['red', '#1FC48D', '#6DC8EC', '#3F8FFF'],
        legend: {
          orient: 'vertical',
          icon: 'none',
          align: 'left',
          x: '55%',
          y: '45%',
          data: ['已完成', '未完成'],
          textStyle: {
            rich: {
              name: { color: '#999', fontSize: 16, height: 20 },
              dpercent: { color: '#999', fontSize: 16, height: 20 },
            },
          },
          formatter(name) {
            for (let i = 0; i < option.series[0].data.length; i++) {
              const dpercent = option.series[0].data[i].value;
              if (option.series[0].data[i].name === name) {
                return [`${name}`, `${dpercent}`].join('：');
              }
            }
          },
        },
        graphic: [{
          type: 'text',
          right: 0,
          top: '5px',
          style: {
            text: `配送车辆总数（${this.totalCount} 辆）`,
            textAlign: 'center',
            fill: '#999',
            fontSize: 16,
          },
        },
        {
          type: 'text',
          left: '30%',
          top: '55%',
          style: {
            text: `${this.opinionData[1].value}/${this.totalCount}`,
            textAlign: 'center',
            fill: '#333',
            fontSize: 24,
            fontWeight: 'bold',
          },
        }],
        series: [
          {
            name: '配送车辆总数',
            type: 'pie',
            radius: ['40%', '55%'],
            center: ['35%', '60%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: '#999',
              },
              color(params) {
                // 自定义颜色
                const colorList = ['#556ec8', '#8ffa78'];
                return colorList[params.dataIndex];
              },
            },
            data: this.opinionData,
          },
        ],
      };
      this.chart.setOption(option);
    },
    // 获取地址
    getAddresses() {
      this.geocoder.getAddress(this.lnglats, (status, result) => {
        if (status === 'complete' && result.regeocodes.length) {
          this.data.forEach((item, index) => {
            item = Object.assign(item, { address: result.regeocodes[index].formattedAddress });
          });
          this.$forceUpdate();
        }
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/monitor.vue